import * as types from '../mutation-types'
import * as nationwideAPI from '@/store/api/nationwide'
import { API } from '@/mixins/constants'
import axios from 'axios'

import { confirmReturnPackage } from '@/store/api/order'

const state = {
  order_id: null,
  order_status: undefined,
  order_active_path: {
    id: undefined,
    status: undefined
  },
  badgeList: [],
  ratingComments: [],
  reports: [],
  tip_info: null,
  secondHideTips: 0,
  secondHideReimbursement: 0
}

// getters
const getters = {
  orderId: (state) => state.order_id,
  orderStatus: (state) => state.order_status,
  orderActivePath: (state) => state.order_active_path,
  badgeList: (state) => state.badgeList,
  ratingComments: (state) => state.ratingComments,
  reports: (state) => state.reports,
  tipInfo: (state) => state.tip_info,
  secondHideTips: (state) => state.secondHideTips,
  secondHideReimbursement: (state) => state.secondHideReimbursement
}

// actions
const actions = {
  setOrderId({ commit }, orderId) {
    commit(types.SET_ORDER_ID, orderId)
  },
  setOrderStatus({ commit }, status) {
    commit(types.SET_ORDER_STATUS, status)
  },
  setActivePath({ commit }, path) {
    commit(types.SET_ORDER_ACTIVE_PATH, path)
  },
  setTipInfo({ commit }, data) {
    commit(types.SET_TIP_INFO, data)
  },
  /* eslint-disable */
  cancelNationwideOrder({ commit }, data) {
    // console.log('commit', commit)
    return nationwideAPI.cancel(data)
  },
  /* eslint-disable */
  confirmReturnedPackage({ commit }, data) {
    let params = {
      token: data.token,
      order_id: data.order_id,
      point_index: data.point_index
    }
    return new Promise((resolve, reject) => {
      confirmReturnPackage(params)
        .then((response) => {
          if (response) {
            resolve(response)
          }
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  setBadgeList({ commit }, deliveryType) {
    return new Promise((resolve, reject) => {
      const url = process.env.VUE_APP_API_URL.concat(API.order.get_badge_list)
      axios
        .get(url, { params: { delivery_type: deliveryType } })
        .then((response) => {
          if (response && response.status === 200) {
            commit(types.SET_BADGE_LIST, response.data)
          }
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },

  setRatingComments({ commit }, ratingParams) {
    return new Promise((resolve, reject) => {
      const url = process.env.VUE_APP_API_URL.concat(API.order.public_rating_comments)
      axios
        .get(url, { params: ratingParams })
        .then((response) => {
          if (response && response.status === 200) {
            commit(types.SET_RATING_COMMENTS, response.data)
          }
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  setReports({ commit }, reportParams) {
    return new Promise((resolve, reject) => {
      const url = process.env.VUE_APP_API_URL.concat(API.order.public_rating_comments)
      axios
        .get(url, { params: reportParams })
        .then((response) => {
          if (response && response.status === 200) {
            commit(types.SET_REPORTS, response.data)
          }
          resolve(response)
        })
        .catch((err) => {
          reject(err)
        })
    })
  },
  setSecondHideTips({ commit }, seconds) {
    commit(types.SET_SECOND_HIDE_TIPS, Number(seconds))
  },
  setSecondHideReimbursement({ commit }, seconds) {
    commit(types.SET_SECOND_HIDE_REIMBURSEMENT, Number(seconds))
  }
}

// mutations
const mutations = {
  [types.SET_ORDER_ID](state, orderId) {
    state.order_id = orderId
  },
  [types.SET_ORDER_STATUS](state, status) {
    state.order_status = status
  },
  [types.SET_ORDER_ACTIVE_PATH](state, path) {
    state.order_active_path = path
  },
  [types.SET_BADGE_LIST](state, data) {
    state.badgeList = [...data]
  },
  [types.SET_RATING_COMMENTS](state, data) {
    state.ratingComments = [...data]
  },
  [types.SET_REPORTS](state, data) {
    state.reports = [...data]
  },
  [types.SET_TIP_INFO](state, data) {
    state.tip_info = data
  },
  [types.SET_SECOND_HIDE_TIPS](state, seconds) {
    state.secondHideTips = seconds
  },
  [types.SET_SECOND_HIDE_REIMBURSEMENT](state, seconds) {
    state.secondHideReimbursement = seconds
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}
